import { render, staticRenderFns } from "./inbody.vue?vue&type=template&id=2d3bc394"
import script from "./inbody.vue?vue&type=script&lang=js"
export * from "./inbody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3bc394')) {
      api.createRecord('2d3bc394', component.options)
    } else {
      api.reload('2d3bc394', component.options)
    }
    module.hot.accept("./inbody.vue?vue&type=template&id=2d3bc394", function () {
      api.rerender('2d3bc394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/inbody.vue"
export default component.exports